import { Vendor } from '../types/vendor';

/**
 * Vendor status configuration for badges and labels
 */
export const VENDOR_STATUS_CONFIG: Record<Vendor['status'], { label: string; color: string }> = {
  active: { label: 'Active', color: 'bg-green-100 text-green-700' },
  inactive: { label: 'Inactive', color: 'bg-gray-100 text-gray-700' },
  pending_approval: { label: 'Pending Approval', color: 'bg-yellow-100 text-yellow-700' },
  suspended: { label: 'Suspended', color: 'bg-red-100 text-red-700' },
  rejected: { label: 'Rejected', color: 'bg-red-100 text-red-700' },
};

/**
 * Filter options for vendor list
 */
export const FILTER_OPTIONS = ['all', 'active', 'pending'] as const;

/**
 * Sort options for vendor list
 */
export const SORT_OPTIONS = [
  { value: 'name', label: 'Name' },
  { value: 'rating', label: 'Rating' },
  { value: 'jobs', label: 'Jobs Completed' },
  { value: 'date', label: 'Date Added' },
] as const;

export type FilterOption = typeof FILTER_OPTIONS[number];
export type SortOption = typeof SORT_OPTIONS[number]['value'];
